export default __webpack_public_path__ + "static/media/video.c3147db9.mov";